import withDriverLocation from "./pages/Driver/withDriverLocation"
import App from "./App";

const AppWithDriverLocation = withDriverLocation(App);

export default AppWithDriverLocation;